import type { ServiceMenuItem } from '@/models/service';
import type { SwiperContainer } from 'swiper/element';
import { ref, onMounted } from 'vue';
import { useWindowSize } from '@vueuse/core';
import { useI18n } from 'vue-i18n';

export const useMenu = (items: ServiceMenuItem[]) => {
  const { locale } = useI18n();
  const { width: windowWidth } = useWindowSize();

  const swiperRef = ref<SwiperContainer | undefined>();
  const shouldHideButtons = ref(false);

  const next = () => {
    swiperRef.value?.swiper.slideNext();
  };

  const prev = () => {
    swiperRef.value?.swiper.slidePrev();
  };

  onMounted(() => {
    swiperRef.value?.initialize();
    swiperRef.value?.classList.add('swiper-initialized');

    swiperRef.value?.swiper.update();
    shouldHideButtons.value = (swiperRef.value?.swiper?.isBeginning && swiperRef.value?.swiper?.isEnd) || !items.length;
  });

  watch(windowWidth, () => {
    swiperRef.value?.swiper.update();
    shouldHideButtons.value = (swiperRef.value?.swiper?.isBeginning && swiperRef.value?.swiper?.isEnd) || !items.length;
  });

  watch(locale, () => {
    swiperRef.value?.swiper.update();

    shouldHideButtons.value = (swiperRef.value?.swiper?.isBeginning && swiperRef.value?.swiper?.isEnd) || !items.length;
  });

  return {
    swiperRef,
    shouldHideButtons,
    prev,
    next
  };
};
